module.exports = __webpack_public_path__ + "img/CosmoFailureTurtle.157d0560.png";